<div class="w-full flex flex-col gap-6">
    @if (!isPharmacyCreate && pharmacies.length > 0) {
        <cdk-accordion class="flex flex-col gap-6">
            <cdk-accordion-item #pharmaciesAcc="cdkAccordionItem" class="mt-8">
                <div
                    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                        (click)="pharmaciesAcc.toggle()" [attr.aria-expanded]="pharmaciesAcc.expanded">
                        <span>Apothekenliste</span>
                        <i class="fa-solid self-center text-xl"
                           [ngClass]="pharmaciesAcc.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                    @if (pharmaciesAcc.expanded) {
                        @for (pharmacy of pharmacies; track pharmacy.id) {
                            <div class="p-6 border-b border-app-primary-10/5">
                                <div class="flex flex-col lg:flex-row justify-between w-full"
                                     [style.display]="pharmacyEditId === pharmacy.id ? 'none' : ''">
                                    <div class="appointment-info flex flex-col">
                                        <div class="text-lg">{{ pharmacy.name }}</div>
                                        <div class="text-xs">
                                            {{ pharmacy.address.street }} {{ pharmacy.address.houseNumber }}
                                        </div>
                                        <div class="text-xs">
                                            {{ pharmacy.address.zipCode }} {{ pharmacy.address.city }}
                                        </div>
                                        <div class="text-xs mt-2">
                                            E-Mail: {{ pharmacy.email }}
                                        </div>
                                        <div class="text-xs">
                                            Fon: {{ pharmacy.phoneNumber }}
                                        </div>
                                    </div>
                                    <div class="appointment-info flex flex-col">
                                        <button class="btn primary-button mt-4"
                                                (click)="triggerPharmacyEdit(pharmacy.id!)">
                                            <span>Apotheke bearbeiten</span>
                                        </button>
                                        <button class="btn secondary-button mt-4"
                                                (click)="openConfirmModal(pharmacy.id!)">
                                            <span>Apotheke löschen</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="p-4 border-b border-app-primary-10/5"
                                     [style.display]="pharmacyEditId === pharmacy.id ? '' : 'none'">
                                    <app-pharmacy-create [pharmacy]="pharmacy"
                                                         (triggerReloadEmitter)="triggerReload($event)"
                                                         (triggerPharmacyCreate)="triggerPharmacyEdit(pharmacyEditId)"></app-pharmacy-create>
                                </div>
                            </div>
                        }
                    }
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    }
    @if (isPharmacyCreate) {
        <app-pharmacy-create (triggerReloadEmitter)="triggerReload($event)"
                             (triggerPharmacyCreate)="triggerPharmacyCreate($event)"></app-pharmacy-create>
    }
    <div class="flex justify-end">
        @if (!isPharmacyCreate) {
            <button class="btn primary-button" (click)="triggerPharmacyCreate(true)">
                <span>Neue Apotheke anlegen</span>
            </button>
        }
    </div>
</div>
